import { colors, typography } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const CardStyled = styled.div`
  position: relative;
  background-color: ${colors.neutral.white};
  border-radius: 1rem;
  padding: 2rem 3.2rem;
  margin-bottom: 3.6rem;

  &:last-of-type {
    margin-bottom: 0;
  }
`;

export const CardHeaderStyled = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 3.6rem;
`;

export const HeaderLeftStyled = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
  flex: 1;
  min-width: 0;
  margin-right: 2rem;
`;

export const DateColumnStyled = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
`;

export const EffectiveDateLabelStyled = styled.h6`
  ${typography.regular[16]};
  color: ${colors.neutral[500]};
  text-transform: uppercase;
  margin: 0 0 0.5rem;
`;

export const EffectiveDateValueStyled = styled.h5`
  ${typography.bold[24]};
  color: ${colors.neutral[900]};
  margin: 0;
  min-width: 13.2rem;
  margin-right: 2rem;
`;

export const FooterStyled = styled.footer`
  display: flex;
  align-items: flex-end;
`;

export const ProposalKeyStyled = styled.span`
  ${typography.regular[16]};
  color: ${colors.neutral[700]};
  padding-right: 2rem;
  width: 13.2rem;
  flex-shrink: 0;
`;

export const ProposalValueStyled = styled.span`
  ${typography.bold[16]};
  color: ${colors.neutral[700]};
  max-width: 48rem;
  min-width: 0;
`;
